import { render, staticRenderFns } from "./material_table_new.vue?vue&type=template&id=3676ccd4&scoped=true"
import script from "./material_table_new.vue?vue&type=script&lang=js"
export * from "./material_table_new.vue?vue&type=script&lang=js"
import style0 from "./material_table_new.vue?vue&type=style&index=0&id=3676ccd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3676ccd4",
  null
  
)

export default component.exports